export default () => {
  const STORAGE_KEY = 'mascotAiClosed';

  const isClosed = () => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      return false;
    }
  };

  const rememberClosed = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {}
  };

  const mascot = document.getElementById('mascot-ai');
  if (!mascot) return;

  if (isClosed()) {
    mascot.classList.add('hidden');
    return;
  }

  const closeBtn = document.getElementById('mascot-ai-close');
  const slides = mascot.querySelectorAll('.er_mascotAi__slide');
  const dots = mascot.querySelectorAll('.er_mascotAi__dot');
  const slideCount = slides.length;
  const autoplayInterval = 4000;
  let currentSlide = 0;
  let timer = null;

  const goToSlide = (index) => {
    slides[currentSlide].classList.remove('active');
    dots[currentSlide].classList.remove('active');
    currentSlide = index % slideCount;
    slides[currentSlide].classList.add('active');
    dots[currentSlide].classList.add('active');
  };

  const nextSlide = () => goToSlide(currentSlide + 1);

  const startAutoplay = () => {
    timer = setInterval(nextSlide, autoplayInterval);
  };

  const stopAutoplay = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  closeBtn.addEventListener('click', () => {
    stopAutoplay();
    rememberClosed();
    mascot.classList.add('hidden');
  });

  const marquizBtn = document.getElementById('mascot-ai-button');
  marquizBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (window.Marquiz) {
      Marquiz.showModal('6a3e2b42b9ac010019b7ac37');
    }
  });

  window.addEventListener('load', () => {
    mascot.classList.add('visible');
    startAutoplay();
  });
};
